export default {"src":"/_next/static/media/phoneContact.1bb50ed2.svg","height":36,"width":36,"blurWidth":0,"blurHeight":0};